import { StateUtils } from '@spartacus/core';
import { EntriesState } from '../../../../../core/features/store/base-feature-state';
import { StatisticsEntry, StatisticsOverview, StatisticsQueryParams, StatisticsSoldTo } from '../model';

export const STATISTICS_FEATURE = 'statistics';

export const STATISTICS_SOLDTO = '[Statistics] Statistics sold-to';
export const STATISTICS_OVERVIEW = '[Statistics] Statistics overview';

export interface StateWithStatistics {
  [STATISTICS_FEATURE]: StatisticsState;
}

export interface StatisticsState {
  soldTos: StateUtils.LoaderState<EntriesState<StatisticsSoldTo>>;
  overview: StateUtils.LoaderState<StatisticsOverview>;
  details: StatisticsDetailsState;
  queryParams: StatisticsQueryParams;
}

export interface StatisticsDetailsState {
  category: StateUtils.LoaderState<StatisticsEntry[]>;
  article: StateUtils.LoaderState<StatisticsEntry[]>;
  month: StateUtils.LoaderState<StatisticsEntry[]>;
}
